import { CheckIcon, Cross2Icon } from "@radix-ui/react-icons";
import { Flex, Link, Table, Text } from "@radix-ui/themes";

interface Scholarship {
  name: string;
  link: string;
  fixedWingBasic: boolean;
  fixedWingAdvance: boolean;
  airExperience: boolean;
  helicopter: boolean;
  gliding: boolean;
  airsports: boolean;
  drone: boolean;
  atpl: boolean;
}

interface ScholarshipTableProps {
  scholarships: Scholarship[];
}

export default function ScholarshipTable({
  scholarships,
}: ScholarshipTableProps) {
  return (
    <section>
      <Table.Root variant="surface" layout="fixed">
        <Table.Header>
          <Table.Row align="center">
            <Table.ColumnHeaderCell width="200px"></Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell justify="center">
              Fixed Wing Basic
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell justify="center">
              Fixed Wing Advanced
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell justify="center">
              Air Experience
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell justify="center">
              Helicopter
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell justify="center">
              Gliding
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell justify="center">
              Airsports
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell justify="center">
              Drone
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell justify="center">
              ATPL Theory
            </Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {scholarships.map((scholarship) => {
            return (
              <Table.Row key={scholarship.name} align="center">
                <Table.RowHeaderCell>
                  <Link
                    href={scholarship.link}
                    color="gray"
                    target="_blank"
                    highContrast
                  >
                    <Flex>
                      <Text as="span" size="2" wrap="balance">
                        {scholarship.name}
                      </Text>
                    </Flex>
                  </Link>
                </Table.RowHeaderCell>
                <Table.Cell>
                  <Flex justify="center">
                    {scholarship.fixedWingBasic ? (
                      <CheckIcon color="green" />
                    ) : (
                      <Cross2Icon color="red" />
                    )}
                  </Flex>
                </Table.Cell>
                <Table.Cell>
                  <Flex justify="center">
                    {scholarship.fixedWingAdvance ? (
                      <CheckIcon color="green" />
                    ) : (
                      <Cross2Icon color="red" />
                    )}
                  </Flex>
                </Table.Cell>
                <Table.Cell>
                  <Flex justify="center">
                    {scholarship.airExperience ? (
                      <CheckIcon color="green" />
                    ) : (
                      <Cross2Icon color="red" />
                    )}
                  </Flex>
                </Table.Cell>
                <Table.Cell>
                  <Flex justify="center">
                    {scholarship.helicopter ? (
                      <CheckIcon color="green" />
                    ) : (
                      <Cross2Icon color="red" />
                    )}
                  </Flex>
                </Table.Cell>
                <Table.Cell>
                  <Flex justify="center">
                    {scholarship.gliding ? (
                      <CheckIcon color="green" />
                    ) : (
                      <Cross2Icon color="red" />
                    )}
                  </Flex>
                </Table.Cell>
                <Table.Cell>
                  <Flex justify="center">
                    {scholarship.airsports ? (
                      <CheckIcon color="green" />
                    ) : (
                      <Cross2Icon color="red" />
                    )}
                  </Flex>
                </Table.Cell>
                <Table.Cell>
                  <Flex justify="center">
                    {scholarship.drone ? (
                      <CheckIcon color="green" />
                    ) : (
                      <Cross2Icon color="red" />
                    )}
                  </Flex>
                </Table.Cell>
                <Table.Cell>
                  <Flex justify="center">
                    {scholarship.atpl ? (
                      <CheckIcon color="green" />
                    ) : (
                      <Cross2Icon color="red" />
                    )}
                  </Flex>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
        <Table.Header>
          <Table.Row align="center">
            <Table.ColumnHeaderCell
              width="200px"
              style={{
                boxShadow: "unset",
                borderTop: "1px solid var(--gray-a5)",
              }}
            ></Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell
              justify="center"
              style={{
                boxShadow: "unset",
                borderTop: "1px solid var(--gray-a5)",
              }}
            >
              Fixed Wing Basic
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell
              justify="center"
              style={{
                boxShadow: "unset",
                borderTop: "1px solid var(--gray-a5)",
              }}
            >
              Fixed Wing Advanced
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell
              justify="center"
              style={{
                boxShadow: "unset",
                borderTop: "1px solid var(--gray-a5)",
              }}
            >
              Air Experience
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell
              justify="center"
              style={{
                boxShadow: "unset",
                borderTop: "1px solid var(--gray-a5)",
              }}
            >
              Helicopter
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell
              justify="center"
              style={{
                boxShadow: "unset",
                borderTop: "1px solid var(--gray-a5)",
              }}
            >
              Gliding
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell
              justify="center"
              style={{
                boxShadow: "unset",
                borderTop: "1px solid var(--gray-a5)",
              }}
            >
              Airsports
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell
              justify="center"
              style={{
                boxShadow: "unset",
                borderTop: "1px solid var(--gray-a5)",
              }}
            >
              Drone
            </Table.ColumnHeaderCell>
            <Table.ColumnHeaderCell
              justify="center"
              style={{
                boxShadow: "unset",
                borderTop: "1px solid var(--gray-a5)",
              }}
            >
              ATPL Theory
            </Table.ColumnHeaderCell>
          </Table.Row>
        </Table.Header>
      </Table.Root>
    </section>
  );
}
